import { Reveal, Eyebrow } from "@/components/Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "How much does a website cost?",
    a: "It depends on the scope. Our packages are starting points — landing pages begin at ₹4,999, business websites at ₹9,999, professional websites at ₹17,999 and e-commerce websites at ₹24,999. After a free consultation you receive a fixed written quote, so the price you approve is the price you pay.",
  },
  {
    q: "How long does it take to build my website?",
    a: "A Starter website typically launches within 2 weeks of receiving your content. Larger websites and web applications usually take 3–6 weeks. Your exact timeline is confirmed in the proposal before any work begins.",
  },
  {
    q: "Do you handle domain registration?",
    a: "Yes. We help you register a domain or connect one you already own. The domain is always registered in your name and your account — you own it, not us.",
  },
  {
    q: "What about hosting?",
    a: "We set up reliable hosting for you and walk you through the costs, which are paid directly by you to the hosting provider. You always have full access to your hosting account.",
  },
  {
    q: "How many revisions do I get?",
    a: "Each package includes a set number of revision rounds (1 to 3). We agree the revision policy in writing before work starts, and additional rounds can be added at a clearly stated rate.",
  },
  {
    q: "What does website maintenance include?",
    a: "Monthly plans cover content updates, bug fixes, monitoring, security and backup checks where your platform supports them, and direct technical support. Anything outside the plan is quoted before we do it — no surprise invoices.",
  },
  {
    q: "Who owns the website when it's finished?",
    a: "You do. On final payment you receive full ownership of the website, its content, the domain and all associated accounts. We keep no lock-in of any kind.",
  },
  {
    q: "How do we get started?",
    a: "Send an enquiry through the contact form or message us on WhatsApp. We'll schedule a free consultation, discuss your goals, and send you a written proposal with scope, timeline and price.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="bg-[#070B16] py-24 lg:py-32" data-testid="faq-section">
      <div className="mx-auto max-w-4xl px-6">
        <Reveal className="text-center">
          <Eyebrow>FAQ</Eyebrow>
          <h2 className="font-display text-4xl font-extrabold tracking-tight text-white sm:text-5xl">
            Questions, answered honestly.
          </h2>
        </Reveal>

        <Reveal delay={0.12}>
          <Accordion type="single" collapsible className="mt-14" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={f.q} value={`item-${i}`} className="border-white/10">
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-left font-display text-base font-bold text-white hover:text-[#00F0FF] hover:no-underline"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm leading-relaxed text-slate-400">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
